export * from './team-performance';
export * from './chat-dashboard';
export * from './email-dashboard';
export * from './omnichannel-dashboard';
export var DashboardBreakdownType;
(function (DashboardBreakdownType) {
    DashboardBreakdownType[DashboardBreakdownType["GROUP"] = 10] = "GROUP";
    DashboardBreakdownType[DashboardBreakdownType["LANGUAGE"] = 20] = "LANGUAGE";
})(DashboardBreakdownType || (DashboardBreakdownType = {}));
export var RealtimeDashboardAggregateMetrics;
(function (RealtimeDashboardAggregateMetrics) {
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["TOTAL_TICKETS"] = 10] = "TOTAL_TICKETS";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["COMPLETED_CHATS"] = 20] = "COMPLETED_CHATS";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["CSAT_SATISFACTION_SCORE"] = 30] = "CSAT_SATISFACTION_SCORE";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["AVG_CHAT_DURATION"] = 40] = "AVG_CHAT_DURATION";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["AVG_FIRST_RESPONSE_DURATION"] = 50] = "AVG_FIRST_RESPONSE_DURATION";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["TOTAL_TRANSFERRED"] = 60] = "TOTAL_TRANSFERRED";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["SOLVED_TICKETS"] = 70] = "SOLVED_TICKETS";
    RealtimeDashboardAggregateMetrics[RealtimeDashboardAggregateMetrics["CLOSED_TICKETS"] = 80] = "CLOSED_TICKETS";
})(RealtimeDashboardAggregateMetrics || (RealtimeDashboardAggregateMetrics = {}));
;
//# sourceMappingURL=index.js.map